import { Download, ExternalLink, FileUser } from 'lucide-react'
import { motion } from 'framer-motion'
import SectionHeader from './SectionHeader'
import { profile } from '../data/profile'

const resumeItems = ['Education', 'Technical Skills', 'Projects', 'Experience']

const Resume = () => {
  return (
    <section id="resume" className="section-shell py-20 md:py-24">
      <div className="grid gap-10 lg:grid-cols-[0.85fr_1.15fr] lg:items-center">
        <SectionHeader
          kicker="Resume"
          title="A concise academic and technical overview."
          text="A concise overview of my education, technical skills, projects, and experience is available in my resume."
        />

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.35 }}
          transition={{ duration: 0.55 }}
          className="card p-6 md:p-8"
        >
          <div className="flex items-start gap-5">
            <span className="rounded-2xl bg-academic-soft p-4 text-academic-blue">
              <FileUser size={26} />
            </span>
            <div>
              <h3 className="text-2xl font-semibold text-academic-text">Resume package</h3>
            </div>
          </div>

          <div className="mt-8 grid gap-3 sm:grid-cols-2">
            {resumeItems.map((item) => (
              <div key={item} className="rounded-2xl border border-academic-line bg-academic-bg px-4 py-3 text-sm font-semibold text-academic-text">
                {item}
              </div>
            ))}
          </div>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <a href={profile.resumeUrl} className="primary-button" download>
              Download Resume <Download className="ml-2" size={17} />
            </a>
            <a href={profile.resumeUrl} className="secondary-button" target="_blank" rel="noreferrer">
              View PDF <ExternalLink className="ml-2" size={17} />
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  )
}

export default Resume
